import actionCreatorFactory from 'typescript-fsa';

/** What's New情報 */
export interface IWHatsNew {
	messageID: string;
	titleList: string[];
	message: string;
	startDateStr: string;
	contact: string;
	careerID: string;
	careerTypeID: number;
	classID: string;
	isBtnApply: number;
	isBtnResultApply: number;
	messageList: string[];
}

const actionCreator = actionCreatorFactory();

/** Whats' New一覧設定アクションクリエータ */
export const setWhatsNewList = actionCreator<{
	whatsNews: IWHatsNew[];
}>('SET_WHATS_NEW_LIST');

/** Whats' New一覧初期化アクションクリエータ */
export const clearWhatsNewList = actionCreator<{}>('CLEAR_WHATS_NEW_LIST');



// WEBPACK FOOTER //
// ./src/actions/whatsNewDetail.ts